
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
import Link from "next/link";
import MainButton from "../../../common/buttons/MainButton";
const HowToBuy = ({ t }) => {
    const how_to_buy = t('home:how_to_buy', {}, { returnObjects: true });
    const HowToBuyItem = ({ item }) => {
        return <li className={'how_to_buy_item'}>
            <span className={'how_to_buy_item_key'}>{item.key}</span>
            {item.key === '1' && <svg xmlns="http://www.w3.org/2000/svg" width="298" height="102" viewBox="0 0 298 102" fill="none">
                <path d="M1.57542 30.0708C0.440802 30.8575 0.158824 32.4151 0.945599 33.5497C1.73237 34.6844 3.28997 34.9663 4.42458 34.1796L1.57542 30.0708ZM289.456 101.065C290.803 101.366 292.139 100.517 292.44 99.1697L297.34 77.2097C297.641 75.8622 296.792 74.526 295.445 74.2253C294.097 73.9246 292.761 74.7732 292.46 76.1208L288.104 95.6407L268.585 91.285C267.237 90.9843 265.901 91.833 265.6 93.1806C265.299 94.5281 266.148 95.8643 267.496 96.165L289.456 101.065ZM3 32.1252L4.42458 34.1796C38.0412 10.8688 91.4818 -0.20106 145.356 8.40636C199.152 17.0015 253.088 45.1721 287.89 99.9655L290 98.6252L292.11 97.2848C256.412 41.0782 201.098 12.2489 146.144 3.46898C91.2682 -5.2986 36.4588 5.88157 1.57542 30.0708L3 32.1252Z" fill="white"/>
            </svg>}
            {item.key === '2' &&
                <svg xmlns="http://www.w3.org/2000/svg" width="282" height="107" viewBox="0 0 282 107" fill="none">
                    <path d="M4.76543 70.3551C3.78783 69.3801 2.20492 69.3822 1.2299 70.3598C0.25488 71.3374 0.25697 72.9203 1.23457 73.8953L4.76543 70.3551ZM272.288 1.99271C271.732 0.729029 270.256 0.155596 268.993 0.711909L248.4 9.77755C247.136 10.3339 246.563 11.8093 247.119 13.0729C247.675 14.3366 249.151 14.91 250.414 14.3537L268.719 6.29538L276.778 24.6001C277.334 25.8638 278.809 26.4372 280.073 25.8809C281.337 25.3246 281.91 23.8492 281.354 22.5855L272.288 1.99271ZM3 72.1252L1.23457 73.8953C13.5667 86.195 33.6949 95.6695 57.4492 101.115C81.2569 106.572 108.956 108.041 136.663 104.116C192.066 96.2666 247.905 66.7505 272.33 3.90566L270 3L267.67 2.09434C244.095 62.7495 190.184 91.4834 135.962 99.1654C108.857 103.006 81.7744 101.561 58.5664 96.241C35.3051 90.9089 16.1833 81.7429 4.76543 70.3551L3 72.1252Z" fill="white"/>
                </svg>}
            {item.key === '3' && <svg xmlns="http://www.w3.org/2000/svg" width="298" height="102" viewBox="0 0 298 102" fill="none">
                <path d="M1.57542 30.0708C0.440802 30.8575 0.158824 32.4151 0.945599 33.5497C1.73237 34.6844 3.28997 34.9663 4.42458 34.1796L1.57542 30.0708ZM289.456 101.065C290.803 101.366 292.139 100.517 292.44 99.1697L297.34 77.2097C297.641 75.8622 296.792 74.526 295.445 74.2253C294.097 73.9246 292.761 74.7732 292.46 76.1208L288.104 95.6407L268.585 91.285C267.237 90.9843 265.901 91.833 265.6 93.1806C265.299 94.5281 266.148 95.8643 267.496 96.165L289.456 101.065ZM3 32.1252L4.42458 34.1796C38.0412 10.8688 91.4818 -0.20106 145.356 8.40636C199.152 17.0015 253.088 45.1721 287.89 99.9655L290 98.6252L292.11 97.2848C256.412 41.0782 201.098 12.2489 146.144 3.46898C91.2682 -5.2986 36.4588 5.88157 1.57542 30.0708L3 32.1252Z" fill="white"/>
            </svg>}
            <div className={'how_to_buy_item_wrapper'}>
                <h3 className={'how_to_buy_item_title'}>{item.title}</h3>
                <p className={'how_to_buy_item_text'}>{item.text}</p>
            </div>
        </li>;
    };
    return (<section className={'how_to_buy'} id={'how-to-buy'}>
            <div className="container">
                <div className="how_to_buy_wrapper">
                    <h2 className={'how_to_buy_title'}>{how_to_buy.title}<br />Pepe Dollar $PEPD</h2>
                    <ul className={'how_to_buy_items'}>
                        {how_to_buy.items.map(item => {
            return <HowToBuyItem key={item.key} item={item}/>;
        })}
                    </ul>
                </div>
            </div>
        </section>);
};
export default HowToBuy;

    async function __Next_Translate__getStaticProps__1989dd500e2__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'components//home/HowToBuy/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1989dd500e2__ as getStaticProps }
  